<div>
    <div class="row align-items-center overview-row mt-5">
        <div class="overview-row__box">
            <div class="main first-box">
                <div class="overview-row__box-icon">
                    <i class="fa fa-clock pull-right"></i>
                </div>
                <div class="overview-row__box-text">
                    {{ l("allocationEnum_NotSubmitted") }}
                </div>
                <div class="overview-row__box-number">
                    {{
                    summary && summary.completedOverdue
                        ? summary.completedOverdue
                        : "-"
                    }}
                </div>
            </div>
        </div>
        <div class="overview-row__box">
            <div class="main second-box">
                <div class="overview-row__box-icon">
                    <i class="fa fa-check pull-right"></i>
                </div>
                <div class="overview-row__box-text">
                    {{ l("allocationEnum_SubmittedBySupervisor") }}
                </div>
                <div class="overview-row__box-number">
                    {{
                    summary && summary.submittedBySupervisor
                        ? summary.submittedBySupervisor
                        : "-"
                    }}
                </div>
            </div>
        </div>
        <div class="overview-row__box">
            <div class="main third-box">
                <div class="overview-row__box-icon">
                    <i class="fa fa-check pull-right"></i>
                </div>
                <div class="overview-row__box-text">
                    {{ l("allocationEnum_SignedOffByForeman") }}
                </div>
                <div class="overview-row__box-number">
                    {{
                    summary && summary.signedOffByForeman
                        ? summary.signedOffByForeman
                        : "-"
                    }}
                </div>
            </div>
        </div>
        <div class="overview-row__box">
            <div class="main fourth-box">
                <div class="overview-row__box-icon">
                    <i class="fa fa-times pull-right"></i>
                </div>
                <div class="overview-row__box-text">
                    {{ l("allocationEnum_RejectedByForeman") }}
                </div>
                <div class="overview-row__box-number">
                    {{
                    summary && summary.rejectedByForeman
                        ? summary.rejectedByForeman
                        : "-"
                    }}
                </div>
            </div>
        </div>
        <div class="overview-row__box">
            <div class="main fifth-box">
                <div class="overview-row__box-icon">
                    <i class="fa fa-times pull-right"></i>
                </div>
                <div class="overview-row__box-text">
                    {{ l("allocationEnum_RejectedByProjectAdmin") }}
                </div>
                <div class="overview-row__box-number">
                    {{
                    summary &&
                    summary.rejectedByProjectAdmin
                        ? summary.rejectedByProjectAdmin
                        : "-"
                    }}
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-12 col-md-7 outstanding-box">
            <h5>{{ l("OutstandingReSubmissions") }}</h5>

            <div
                class="alert alert-info"
                *ngIf="
                    !outstandingLoading && !outstanding.length
                "
            >
                {{ l("NoData") }}
            </div>

            <div *ngIf="!outstandingLoading && outstanding.length">
                <table class="table mt-2">
                    <tr>
                        <th>{{ l('Date') }}</th>
                        <th>{{ l('Supervisor') }}</th>
                        <th>{{ l('Status') }}</th>
                    </tr>
                    <tr *ngFor="let out of outstanding">
                        <td>{{ out.submissionDay | humanizeDate }}</td>
                        <td>{{ out.creator.firstName }} {{ out.creator.lastName }}</td>
                        <td>
                            {{out.reason}}
                            <app-sheet-status
                                [reason]="out.reason"
                                [allocationSheetId]="out.id"

                            >
                            </app-sheet-status>
                        </td>
                    </tr>
                </table>
                <div>
                    <a href="/app/main/resourcesAllocation/allocation-sheets">
                        {{ l('SeeAll') }}
                    </a>
                </div>
            </div>

        </div>
        <div class="col-12 col-md-5 submissions-box">
            <h5>
                {{ l("OverdueActivitySubmissions") }}
                <i
                    class="fas fa-search pull-right cursor-pointer"
                    (click)="toggleSearch()"
                    [matTooltip]="l('Search')"
                ></i>
            </h5>

            <div *ngIf="searchVisible">
                <input
                    (keyup.enter)="getOverdue($event)"
                    (blur)="getOverdue($event)"
                    class="form-control"
                    placeholder="search..."
                    autoFocus
                />
            </div>

            <table
                class="table mt-2"
                *ngIf="!overdueLoading && overdue.length && !isGranted('Pages.Detailed.Overdue.Activity')"
            >
                <tr>
                    <th>{{ l('Supervisor') }}</th>
                    <th>{{ l('Activities') }}</th>
                    <th>{{ l('Days') }}</th>
                </tr>
                <tr *ngFor="let over of overdue">
                    <td>
                        {{ over.supervisor?.firstName }}
                        {{ over.supervisor?.lastName }}
                    </td>
                    <td>{{ over.activities }}</td>
                    <td>{{ over.days }}</td>
                </tr>
            </table>

            <table
                class="table mt-2"
                *ngIf="!overdueLoading && overdue.length && isGranted('Pages.Detailed.Overdue.Activity')"
            >
                <tr>
                    <th>{{ l('Activity') }}</th>
                    <th style="width: 120px;" class="text-right">{{ l('ActivityDay') }}</th>
                </tr>
                <tr *ngFor="let over of overdue">
                    <td>
                        <div>
                            <span class="main-color">{{ over.assetCode }}</span>
                            <span *ngIf="over.assetCode || over.activityType"> | </span>
                            <span>{{ over.activityType}}</span>
                        </div>
                        {{ over.activityName }}
                    </td>
                    <td class="text-right">{{ over.activityDay | humanizeDate }}</td>
                </tr>
            </table>
        </div>
    </div>
</div>
